declare let THREE: any;

export const common = {
  startAtY: 1000,
  raycastAtY: 10000
};

export const createBorder = function (planeGeometry) {
  const edges = new THREE.EdgesGeometry(planeGeometry);
  const material = new THREE.LineBasicMaterial({
    color: 0x000000
  });
  return new THREE.LineSegments(edges, material);
};



// WEBPACK FOOTER //
// ./src/app/services/proTools/common.ts